import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FunctionsHelper } from 'src/app/helpers/functions';
import { AuthService } from 'src/app/shared/auth.service';

@Component({
  selector: 'app-auth-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  submitClicked: boolean = false;
  formSubmitted: boolean = false;
  error: string = '';

  loginForm: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  get loginFormControl() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitClicked = true;
    this.error = '';

    if (this.loginForm.valid) {
      this.formSubmitted = true;

      this.authService.login(this.loginForm.value.username, this.loginForm.value.password)
        .subscribe({
          next: () => {
            if (this.authService.userLoggedIn) {
              this.loginForm.reset();
              this.router.navigate(['reports']);
            }
          },
          error: (err) => {
            if (err && err.error && err.error.statusCode === 401) {
              this.error = 'Invalid username or password. Try again!';
            } else {
              this.error = 'Something went wrong. Try again!';
            }
            this.formSubmitted = false;
          }
        });
    }
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private _functionsHelper: FunctionsHelper,
    private toastr: ToastrService,
    private renderer: Renderer2
  ) {
    if (this.router.getCurrentNavigation()?.extras.state?.['passwordReset']) {
      this.toastr.success('Password changed successfully.');
    }
  }

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'login-page');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login-page');
  }
}
